import * as ss from 'superstruct';
import { Id } from '../types';
import { AdAccountResource } from './ad-account.resource';
import { IsoDate } from '../../../utils/iso-date';
import { AdDataStreamSourceConfig } from './ad-data-stream-sources';

/**
 * Pulls one ad account's daily performance and its campaigns, ad groups
 * and ads from its platform.
 */
export const AdDataStreamResource = ss.type({
  id: Id,
  adAccount: AdAccountResource,
  description: ss.optional(ss.nullable(ss.string())),
  enabled: ss.boolean(),
  source: AdDataStreamSourceConfig,
  /** First day to pull. Can't change after the stream is created. */
  startDate: IsoDate,
  /** Last complete day synced; later days are re-read on each run. */
  syncedThroughDate: ss.optional(ss.nullable(IsoDate)),
  lastRunAt: ss.optional(ss.nullable(ss.date())),
  lastSuccessAt: ss.optional(ss.nullable(ss.date())),
  lastError: ss.optional(ss.nullable(ss.string())),
  /** The daily sync of the ad account's settings, goals and change history. */
  settingsLastRunAt: ss.optional(ss.nullable(ss.date())),
  settingsLastSuccessAt: ss.optional(ss.nullable(ss.date())),
  settingsLastError: ss.optional(ss.nullable(ss.string())),
  settingsSyncedTypes: ss.optional(ss.nullable(ss.array(ss.string()))),
  createdAt: ss.optional(ss.nullable(ss.date())),
  updatedAt: ss.optional(ss.nullable(ss.date())),
});

export type AdDataStreamResource = ss.Infer<typeof AdDataStreamResource>;

/** Body of `POST /api/ad-data-streams/:id/sync`. */
export const AdDataStreamSyncRequest = ss.type({
  /** Re-pull from this day (clamped to the stream's start date). */
  resyncFrom: ss.optional(IsoDate),
});

export type AdDataStreamSyncRequest = ss.Infer<typeof AdDataStreamSyncRequest>;
